import { Stack, styled, Typography } from "@mui/material"

import { Reserves } from "../../ao/pool"
import { TokenInfo } from "../../ao/token"
import { NumberFont } from "../../theme"
import { formatNumberAuto, formatTicker } from "../../utils/format"

type AddOrderDetailsProps = {
  currentPoolShare: bigint | null
  newPoolShare: bigint | null
  feePercentageBps: bigint
  lpAmountExpected: bigint
  lpToken?: TokenInfo
  receiveAtLeast: string
  slippage: number
  tokenA: TokenInfo
  tokenB: TokenInfo
  tokenAPrice: number
  tokenBPrice: number
  reserves?: Reserves
}

export function AddOrderDetails(props: AddOrderDetailsProps) {
  const {
    currentPoolShare,
    newPoolShare,
    feePercentageBps,
    lpAmountExpected,
    lpToken,
    receiveAtLeast,
    slippage,
    tokenA,
    tokenAPrice,
    tokenB,
    tokenBPrice,
    reserves,
  } = props

  return (
    <>
      {/* <DetailsRow>
        <span>Pool fee</span>
        <span>{Number(feePercentageBps) / 1000}%</span>
      </DetailsRow> */}
      {typeof currentPoolShare === "bigint" && (
        <DetailsRow>
          <span>Current Pool Share</span>
          <Typography variant="inherit" component="span">
            {(Number(currentPoolShare) / 100).toFixed(2)}%
          </Typography>
        </DetailsRow>
      )}
      {typeof newPoolShare === "bigint" && (
        <DetailsRow>
          <span>Your New Total Share of Pool</span>
          <Typography variant="inherit" component="span">
            {(Number(newPoolShare) / 100).toFixed(2)}%
          </Typography>
        </DetailsRow>
      )}
      <DetailsRow>
        <span>Your Pool Fee Earnings</span>
        <span>{Number(feePercentageBps) / 100}%</span>
      </DetailsRow>
      <DetailsRow>
        <span>{formatTicker(tokenA.ticker, true)} price</span>
        <span>
          {formatNumberAuto(tokenAPrice)} {formatTicker(tokenB.ticker, true)}
        </span>
      </DetailsRow>
      <DetailsRow>
        <span>{formatTicker(tokenB.ticker, true)} price</span>
        <span>
          {formatNumberAuto(tokenBPrice)} {formatTicker(tokenA.ticker, true)}
        </span>
      </DetailsRow>
      <DetailsRow>
        <span>Max slippage</span>
        <span>{slippage}%</span>
      </DetailsRow>
      {/* <DetailsRow>
        <span>Expected output</span>
        <span>
          {parseBigIntAsNumber(lpAmountExpected, lpToken?.denomination, lpToken?.denomination)}{" "}
          {formatTicker(lpToken?.ticker)}
        </span>
      </DetailsRow> */}
      {/* <DetailsRow>
        <span>Receive at least</span>
        <span>
          {receiveAtLeast} {lpToken?.ticker}
        </span>
      </DetailsRow> */}
      {/* <DetailsRow>
        <span>Pool reserves</span>
        <span>
          {parseBigIntAsNumber(
            reserves?.[tokenA.id] || 0n,
            tokenA?.denomination,
            tokenA?.denomination,
          )}{" "}
          {formatTicker(tokenA.ticker)}
        </span>
      </DetailsRow>
      <DetailsRow>
        <span>Pool reserves</span>
        <span>
          {parseBigIntAsNumber(
            reserves?.[tokenB.id] || 0n,
            tokenB?.denomination,
            tokenB?.denomination,
          )}{" "}
          {formatTicker(tokenB.ticker)}
        </span>
      </DetailsRow> */}
      <DetailsRow>
        <span>Network cost</span>
        <span>0 AO</span>
      </DetailsRow>
    </>
  )
}

const DetailsRow = styled(Stack)`
  flex-direction: row;
  justify-content: space-between;

  & > span:first-of-type {
    white-space: nowrap;
    color: var(--mui-palette-secondary-main);
  }

  & > span:last-of-type {
    white-space: nowrap;
    font-family: ${NumberFont};
  }
`
